import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { UrlService } from 'app/core/http/url.service';

@Injectable({
  providedIn: 'root'
})
export class DistrictLoginGuard {
  private readonly urlService = inject(UrlService);

  public canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const redirectUrl = new URL(this.urlService.buildServerApiUrl('DistrictLogin'), window.location.origin);
    redirectUrl.search = new URL(state.url, window.location.origin).search;
    window.location.replace(redirectUrl.href);

    return false;
  }
}
